import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

// Define a type for additional data
type AdditionalData = {
  uid: string | undefined;
  streamName: string;
  imageUrl: string;
  streamColor: string;
};

export const trackClick = (clickName: string, additionalData?: AdditionalData): void => {
  try {
    var eventParams = {
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent,
      screen_width: window.innerWidth,
      screen_height: window.innerHeight,
      referrer: document.referrer,
      url: window.location.href,
      user_language: navigator.language, //|| navigator.userLanguage,
      user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      user_id: localStorage.getItem("user_id") || undefined,
      // session_id: localStorage.getItem("session_id") || undefined
    }
    if (additionalData) {
      eventParams = { ...eventParams, ...additionalData };
    }
    logEvent(analytics, clickName, eventParams);
    console.log("Event logged successfully");
  } catch (error) {
    console.error("Error logging event:", error);
  }
};